export default __webpack_public_path__ + "static/media/Swift&Allied.079f3f2b.png";